import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS PREVIDENCIÁRIOS
// ============================================

// Inicial de Ação de Concessão de Benefício Previdenciário
export const CONCESSAO_BENEFICIO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Inicial de Ação de Concessão de Benefício Previdenciário',
  description: 'Ação judicial para concessão de benefício previdenciário negado administrativamente',
  suggestedDocs: 'Carta de indeferimento do INSS, CNIS, Documentos médicos e Processo administrativo.',
  infoTip: 'Demonstre o preenchimento dos requisitos legais para concessão do benefício e a negativa indevida do INSS.',
};
export const ConcessaoBeneficioForm = createFormFromConfig(CONCESSAO_BENEFICIO_CONFIG);

// Ação de Revisão de Benefício Previdenciário
export const REVISAO_BENEFICIO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Ação de Revisão de Benefício Previdenciário',
  description: 'Ação para revisar valor ou forma de cálculo de benefício previdenciário',
  suggestedDocs: 'Carta de concessão, CNIS, Demonstrativo de cálculo e Processo administrativo.',
  infoTip: 'Demonstre o erro de cálculo ou a aplicação incorreta da legislação no cálculo do benefício.',
};
export const RevisaoBeneficioForm = createFormFromConfig(REVISAO_BENEFICIO_CONFIG);

// Requerimento de Concessão de Benefício Previdenciário
export const REQUERIMENTO_BENEFICIO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Requerimento de Concessão de Benefício Previdenciário',
  description: 'Requerimento administrativo de benefício previdenciário',
  suggestedDocs: 'CNIS, Documentos de identificação, Documentos médicos e comprovantes.',
  infoTip: 'Apresente todos os documentos que comprovem o direito ao benefício requerido.',
};
export const RequerimentoBeneficioForm = createFormFromConfig(REQUERIMENTO_BENEFICIO_CONFIG);

// Recurso Especial Previdenciário (CRPS/INSS)
export const RECURSO_ESPECIAL_CRPS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Especial Previdenciário (CRPS/INSS)',
  description: 'Recurso ao Conselho de Recursos da Previdência Social',
  suggestedDocs: 'Decisão da Junta de Recursos, Processo administrativo e Documentos comprobatórios.',
  defaultPecaRebater: 'Decisão da Junta de Recursos',
  pecaRebaterHelper: 'Indique a decisão administrativa que deseja recorrer',
  infoTip: 'Demonstre o erro da decisão da Junta de Recursos e fundamente o pedido de reforma.',
};
export const RecursoEspecialCRPSForm = createFormFromConfig(RECURSO_ESPECIAL_CRPS_CONFIG);

// Recurso Ordinário Previdenciário (CRPS/INSS)
export const RECURSO_ORDINARIO_CRPS_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Ordinário Previdenciário (CRPS/INSS)',
  description: 'Recurso ordinário à Junta de Recursos do INSS',
  suggestedDocs: 'Decisão do INSS, Processo administrativo e Documentos comprobatórios.',
  defaultPecaRebater: 'Decisão do INSS',
  pecaRebaterHelper: 'Indique a decisão administrativa que deseja recorrer',
  infoTip: 'Demonstre o erro da decisão administrativa do INSS e fundamente o pedido de reforma.',
};
export const RecursoOrdinarioCRPSForm = createFormFromConfig(RECURSO_ORDINARIO_CRPS_CONFIG);

// Emenda à Inicial Previdenciária
export const EMENDA_INICIAL_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Emenda à Inicial (Previdenciário)',
  description: 'Correção ou complementação da petição inicial previdenciária',
  suggestedDocs: 'Despacho judicial e Documentos complementares.',
  defaultPecaRebater: 'Despacho',
  pecaRebaterHelper: 'Indique o despacho que determinou a emenda',
  infoTip: 'Atenda às determinações do juízo para sanar vícios ou complementar a petição inicial.',
};
export const EmendaInicialPrevidenciarioForm = createFormFromConfig(EMENDA_INICIAL_PREVIDENCIARIO_CONFIG);

// Contestação Previdenciária
export const CONTESTACAO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contestação (Previdenciário)',
  description: 'Defesa do INSS em ação previdenciária',
  suggestedDocs: 'Petição inicial, Processo administrativo e Documentos do segurado.',
  defaultPecaRebater: 'Petição Inicial',
  pecaRebaterHelper: 'Indique a petição inicial que deseja contestar',
  infoTip: 'Apresente os fundamentos de fato e de direito para impugnar os pedidos da parte autora.',
};
export const ContestacaoPrevidenciarioForm = createFormFromConfig(CONTESTACAO_PREVIDENCIARIO_CONFIG);

// Impugnação à Contestação (Réplica) Previdenciária
export const REPLICA_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Contestação (Réplica) (Previdenciário)',
  description: 'Resposta à contestação do INSS',
  suggestedDocs: 'Contestação, Petição inicial e Processo na íntegra.',
  defaultPecaRebater: 'Contestação',
  pecaRebaterHelper: 'Indique a contestação que deseja rebater',
  infoTip: 'Rebata os argumentos da contestação e reforce o direito ao benefício.',
};
export const ReplicaPrevidenciarioForm = createFormFromConfig(REPLICA_PREVIDENCIARIO_CONFIG);

// Manifestação Processual Previdenciária
export const MANIFESTACAO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Manifestação Processual (Previdenciário)',
  description: 'Manifestação genérica em processo previdenciário',
  suggestedDocs: 'Processo na íntegra.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Despacho judicial feito na data de 21/05/2025',
  infoTip: 'Manifeste-se sobre o ponto específico determinado pelo juízo ou de interesse da parte.',
};
export const ManifestacaoPrevidenciarioForm = createFormFromConfig(MANIFESTACAO_PREVIDENCIARIO_CONFIG);

// Manifestação para Produção de Provas Previdenciária
export const PRODUCAO_PROVAS_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação para Produção de Provas (Previdenciário)',
  description: 'Requerimento de produção de provas em processo previdenciário',
  suggestedDocs: 'Despacho que determinou especificação de provas e Processo na íntegra.',
  defaultPecaRebater: 'Despacho',
  pecaRebaterHelper: 'Indique o despacho que determinou a especificação de provas',
  infoTip: 'Especifique as provas necessárias e justifique a pertinência de cada uma.',
};
export const ProducaoProvasPrevidenciarioForm = createFormFromConfig(PRODUCAO_PROVAS_PREVIDENCIARIO_CONFIG);

// Manifestação para Apresentação de Quesitos Periciais Previdenciária
export const QUESITOS_PERICIAIS_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação para Apresentação de Quesitos Periciais (Previdenciário)',
  description: 'Formulação de quesitos para perícia médica previdenciária',
  suggestedDocs: 'Despacho que determinou a perícia e Processo na íntegra.',
  defaultPecaRebater: 'Despacho que determina apresentação de quesitos',
  pecaRebaterHelper: 'Indique o despacho que determinou a apresentação de quesitos',
  infoTip: 'Formule quesitos objetivos e relevantes para comprovar a incapacidade ou condição do segurado.',
};
export const QuesitosPericiaisisPrevidenciarioForm = createFormFromConfig(QUESITOS_PERICIAIS_PREVIDENCIARIO_CONFIG);

// Alegações Finais Previdenciárias
export const ALEGACOES_FINAIS_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Alegações Finais (Previdenciário)',
  description: 'Razões finais em processo previdenciário',
  suggestedDocs: 'Contestação, Petição inicial, Processo na íntegra e Laudo pericial.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Refere-se ao processo previdenciário completo',
  infoTip: 'Analise as provas produzidas, especialmente o laudo pericial, e reforce o direito ao benefício.',
};
export const AlegacoesFinaisPrevidenciarioForm = createFormFromConfig(ALEGACOES_FINAIS_PREVIDENCIARIO_CONFIG);

// Recurso Inominado Previdenciário
export const RECURSO_INOMINADO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Inominado (Previdenciário)',
  description: 'Recurso contra sentença do Juizado Especial Federal',
  suggestedDocs: 'Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que deseja recorrer',
  infoTip: 'Demonstre o erro da sentença e fundamente o pedido de reforma com base nas provas dos autos.',
};
export const RecursoInominadoPrevidenciarioForm = createFormFromConfig(RECURSO_INOMINADO_PREVIDENCIARIO_CONFIG);

// Apelação Previdenciária
export const APELACAO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Apelação (Previdenciário)',
  description: 'Recurso contra sentença em ação previdenciária',
  suggestedDocs: 'Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que deseja apelar',
  infoTip: 'Ataque os fundamentos da sentença e demonstre os erros de fato ou de direito.',
};
export const ApelacaoPrevidenciarioForm = createFormFromConfig(APELACAO_PREVIDENCIARIO_CONFIG);

// Contrarrazões de Apelação Previdenciária
export const CONTRARRAZOES_APELACAO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões de Apelação (Previdenciário)',
  description: 'Resposta à apelação do INSS em processo previdenciário',
  suggestedDocs: 'Apelação, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Apelação',
  pecaRebaterHelper: 'Indique a apelação que deseja contrarrazoar',
  infoTip: 'Defenda a manutenção da sentença, rebatendo os argumentos do INSS.',
};
export const ContrarrazoesApelacaoPrevidenciarioForm = createFormFromConfig(CONTRARRAZOES_APELACAO_PREVIDENCIARIO_CONFIG);

// Agravo de Instrumento Previdenciário
export const AGRAVO_INSTRUMENTO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo de Instrumento (Previdenciário)',
  description: 'Recurso contra decisões interlocutórias em processo previdenciário',
  suggestedDocs: 'Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Interlocutória',
  pecaRebaterHelper: 'Indique a decisão interlocutória que deseja agravar',
  infoTip: 'Demonstre o erro da decisão interlocutória e o prejuízo causado à parte.',
};
export const AgravoInstrumentoPrevidenciarioForm = createFormFromConfig(AGRAVO_INSTRUMENTO_PREVIDENCIARIO_CONFIG);

// Contraminuta ao Agravo de Instrumento Previdenciário
export const CONTRAMINUTA_AGRAVO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo de Instrumento (Previdenciário)',
  description: 'Resposta ao agravo de instrumento em processo previdenciário',
  suggestedDocs: 'Agravo de instrumento, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo de Instrumento',
  pecaRebaterHelper: 'Indique o agravo de instrumento que deseja responder',
  infoTip: 'Defenda a manutenção da decisão agravada.',
};
export const ContraminutaAgravoPrevidenciarioForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_PREVIDENCIARIO_CONFIG);

// Agravo Interno Previdenciário
export const AGRAVO_INTERNO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo Interno (Previdenciário)',
  description: 'Recurso contra decisão monocrática em processo previdenciário',
  suggestedDocs: 'Decisão monocrática e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Monocrática',
  pecaRebaterHelper: 'Indique a decisão monocrática que deseja agravar',
  infoTip: 'Demonstre o erro da decisão monocrática e a necessidade de julgamento pelo colegiado.',
};
export const AgravoInternoPrevidenciarioForm = createFormFromConfig(AGRAVO_INTERNO_PREVIDENCIARIO_CONFIG);

// Contraminuta ao Agravo Interno Previdenciário
export const CONTRAMINUTA_AGRAVO_INTERNO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo Interno (Previdenciário)',
  description: 'Resposta ao agravo interno em processo previdenciário',
  suggestedDocs: 'Agravo interno, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo Interno',
  pecaRebaterHelper: 'Indique o agravo interno que deseja responder',
  infoTip: 'Defenda a manutenção da decisão monocrática.',
};
export const ContraminutaAgravoInternoPrevidenciarioForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_INTERNO_PREVIDENCIARIO_CONFIG);

// Cumprimento de Sentença Previdenciário
export const CUMPRIMENTO_SENTENCA_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Cumprimento de Sentença (Previdenciário)',
  description: 'Execução de sentença previdenciária',
  suggestedDocs: 'Cálculos, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que será executada',
  infoTip: 'Apresente os cálculos de liquidação e requeira a implantação do benefício e pagamento dos atrasados.',
};
export const CumprimentoSentencaPrevidenciarioForm = createFormFromConfig(CUMPRIMENTO_SENTENCA_PREVIDENCIARIO_CONFIG);

// Impugnação ao Cumprimento de Sentença Previdenciário
export const IMPUGNACAO_CUMPRIMENTO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação ao Cumprimento de Sentença (Previdenciário)',
  description: 'Defesa do INSS ao cumprimento de sentença',
  suggestedDocs: 'Cálculos, Cumprimento de sentença e Processo na íntegra.',
  defaultPecaRebater: 'Cumprimento de Sentença',
  pecaRebaterHelper: 'Indique o pedido de cumprimento de sentença que deseja impugnar',
  infoTip: 'Aponte excesso de execução ou outras matérias de defesa.',
};
export const ImpugnacaoCumprimentoPrevidenciarioForm = createFormFromConfig(IMPUGNACAO_CUMPRIMENTO_PREVIDENCIARIO_CONFIG);

// Impugnação à Sentença de Homologação dos Cálculos Previdenciário
export const IMPUGNACAO_HOMOLOGACAO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Sentença de Homologação dos Cálculos (Previdenciário)',
  description: 'Manifestação discordando dos cálculos homologados',
  suggestedDocs: 'Planilha de cálculos, Processo na íntegra e Sentença homologatória.',
  defaultPecaRebater: 'Sentença de Homologação dos Cálculos',
  pecaRebaterHelper: 'Indique a sentença que homologou os cálculos',
  infoTip: 'Aponte especificamente os erros de cálculo, sob pena de preclusão.',
};
export const ImpugnacaoHomologacaoPrevidenciarioForm = createFormFromConfig(IMPUGNACAO_HOMOLOGACAO_PREVIDENCIARIO_CONFIG);

// Memoriais Recursais Previdenciário
export const MEMORIAIS_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais (Previdenciário)',
  description: 'Memoriais para julgamento de recurso previdenciário',
  suggestedDocs: 'Acórdão, Processo na íntegra, Razões recursais e Sentença.',
  defaultPecaRebater: 'Razões Recursais',
  pecaRebaterHelper: 'Indique as razões recursais apresentadas',
  infoTip: 'Reforce os principais argumentos do recurso e apresente jurisprudência favorável.',
};
export const MemoriaisPrevidenciarioForm = createFormFromConfig(MEMORIAIS_PREVIDENCIARIO_CONFIG);

// Memoriais Recursais para Ministro do STJ Previdenciário
export const MEMORIAIS_STJ_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais para Ministro do STJ (Previdenciário)',
  description: 'Memoriais direcionados a Ministro do STJ em processo previdenciário',
  suggestedDocs: 'Acórdão, Decisão impugnada, Processo na íntegra e Razões recursais.',
  defaultPecaRebater: 'Razões Recursais',
  pecaRebaterHelper: 'Indique as razões recursais apresentadas',
  infoTip: 'Destaque a relevância da questão federal e a jurisprudência favorável do STJ.',
};
export const MemoriaisSTJPrevidenciarioForm = createFormFromConfig(MEMORIAIS_STJ_PREVIDENCIARIO_CONFIG);

// Recurso Especial Previdenciário
export const RECURSO_ESPECIAL_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Especial (Previdenciário)',
  description: 'Recurso ao STJ por violação à lei federal em matéria previdenciária',
  suggestedDocs: 'Acórdão, Embargos de declaração e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que violou lei federal',
  infoTip: 'Demonstre a violação à lei federal previdenciária ou a divergência jurisprudencial.',
};
export const RecursoEspecialPrevidenciarioForm = createFormFromConfig(RECURSO_ESPECIAL_PREVIDENCIARIO_CONFIG);

// Contrarrazões ao Recurso Especial Previdenciário
export const CONTRARRAZOES_RESP_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Especial (Previdenciário)',
  description: 'Resposta ao REsp em processo previdenciário',
  suggestedDocs: 'Acórdão, Processo na íntegra e REsp.',
  defaultPecaRebater: 'Recurso Especial',
  pecaRebaterHelper: 'Indique o recurso especial que deseja contrarrazoar',
  infoTip: 'Demonstre a correção do acórdão recorrido.',
};
export const ContrarrazoesRespPrevidenciarioForm = createFormFromConfig(CONTRARRAZOES_RESP_PREVIDENCIARIO_CONFIG);

// Recurso Extraordinário Previdenciário
export const RECURSO_EXTRAORDINARIO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Extraordinário (Previdenciário)',
  description: 'Recurso ao STF por violação à Constituição em matéria previdenciária',
  suggestedDocs: 'Acórdão, Decisão de admissibilidade e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que viola a Constituição',
  infoTip: 'Demonstre a violação direta à Constituição e a repercussão geral da matéria.',
};
export const RecursoExtraordinarioPrevidenciarioForm = createFormFromConfig(RECURSO_EXTRAORDINARIO_PREVIDENCIARIO_CONFIG);

// Contrarrazões ao Recurso Extraordinário Previdenciário
export const CONTRARRAZOES_RE_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Extraordinário (Previdenciário)',
  description: 'Resposta ao RE em processo previdenciário',
  suggestedDocs: 'Acórdão, Processo na íntegra e RE.',
  defaultPecaRebater: 'Recurso Extraordinário',
  pecaRebaterHelper: 'Indique o recurso extraordinário que deseja contrarrazoar',
  infoTip: 'Demonstre a ausência de repercussão geral ou a inexistência de violação à Constituição.',
};
export const ContrarrazoesREPrevidenciarioForm = createFormFromConfig(CONTRARRAZOES_RE_PREVIDENCIARIO_CONFIG);

// Agravo em Recurso Especial Previdenciário
export const AGRAVO_RESP_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo em Recurso Especial (Previdenciário)',
  description: 'Agravo contra decisão que inadmitiu REsp previdenciário',
  suggestedDocs: 'Decisão que inadmitiu o REsp e Processo na íntegra.',
  defaultPecaRebater: 'Despacho Denegatório',
  pecaRebaterHelper: 'Indique a decisão que inadmitiu o recurso especial',
  infoTip: 'Demonstre o equívoco da decisão de inadmissão.',
};
export const AgravoRespPrevidenciarioForm = createFormFromConfig(AGRAVO_RESP_PREVIDENCIARIO_CONFIG);

// Contraminuta ao Agravo em Recurso Especial Previdenciário
export const CONTRAMINUTA_AGRAVO_RESP_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo em Recurso Especial (Previdenciário)',
  description: 'Resposta ao agravo em REsp previdenciário',
  suggestedDocs: 'Agravo em REsp, Processo na íntegra e REsp.',
  defaultPecaRebater: 'Agravo em Recurso Especial',
  pecaRebaterHelper: 'Indique o agravo que deseja responder',
  infoTip: 'Defenda a decisão de inadmissão do REsp.',
};
export const ContraminutaAgravoRespPrevidenciarioForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_RESP_PREVIDENCIARIO_CONFIG);

// Recurso Ordinário Constitucional Previdenciário
export const RECURSO_ORDINARIO_CONSTITUCIONAL_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Ordinário Constitucional (Previdenciário)',
  description: 'Recurso ao STF/STJ em mandado de segurança previdenciário',
  suggestedDocs: 'Acórdão denegatório, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Decisão Denegatória',
  pecaRebaterHelper: 'Indique a decisão que denegou a ordem',
  infoTip: 'Demonstre o cabimento do ROC e as razões para reforma da decisão.',
};
export const RecursoOrdinarioConstitucionalPrevidenciarioForm = createFormFromConfig(RECURSO_ORDINARIO_CONSTITUCIONAL_PREVIDENCIARIO_CONFIG);

// Mandado de Segurança Previdenciário
export const MANDADO_SEGURANCA_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Mandado de Segurança (Previdenciário)',
  description: 'Ação para proteger direito líquido e certo violado pelo INSS',
  suggestedDocs: 'Decisão atacada, provas do direito líquido e certo e Processo administrativo.',
  infoTip: 'Demonstre claramente o direito líquido e certo e a ilegalidade ou abuso de poder do INSS.',
};
export const MandadoSegurancaPrevidenciarioForm = createFormFromConfig(MANDADO_SEGURANCA_PREVIDENCIARIO_CONFIG);

// Pedido de Expedição de RPV Previdenciário
export const RPV_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Pedido de Expedição de Requisição de Pequeno Valor (RPV) (Previdenciário)',
  description: 'Requerimento para pagamento de RPV previdenciária',
  suggestedDocs: 'Cálculos homologados, Processo na íntegra e Sentença transitada.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença transitada em julgado',
  infoTip: 'Requeira a expedição da RPV após o trânsito em julgado, observando o teto legal.',
};
export const RPVPrevidenciarioForm = createFormFromConfig(RPV_PREVIDENCIARIO_CONFIG);

// Peça a partir de Modelo Previdenciário
export const PECA_MODELO_PREVIDENCIARIO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Peça a partir de Modelo (Previdenciário)',
  description: 'Adaptar modelo de peça previdenciária para novo caso',
  suggestedDocs: 'Modelo a ser adaptado e documentos do novo caso.',
  defaultPecaRebater: 'Modelo Original',
  pecaRebaterHelper: 'Faça upload do modelo que deseja adaptar',
  infoTip: 'A IA adaptará a estrutura e argumentos do modelo para os fatos do seu caso.',
};
export const PecaModeloPrevidenciarioForm = createFormFromConfig(PECA_MODELO_PREVIDENCIARIO_CONFIG);

